<template>
  <div>
    <div class="mb-40">
      <div >
        <el-button type="primary" round size="small" @click="add_class">套餐设置
          <span style="font-size: 14px;margin-left: 5px;" class="iconfont icon-add"></span></el-button>
      </div>
      <el-table :data="post.class" border stripe style="margin: 20px auto">
        <el-table-column label="套餐" width="">
          <template v-slot="scope">
            <el-input v-model="scope.row.title" placeholder="套餐"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="费用" width="">
          <template v-slot="scope">
            <el-input v-model.number="scope.row.price" placeholder="费用"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="书本总数量" width="">
          <template v-slot="scope">
            <el-input v-model.number="scope.row.ebook_total" placeholder="书本总数量"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="微页总数量" width="">
          <template v-slot="scope">
            <el-input v-model.number="scope.row.page_total" placeholder="微页总数量"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="赠送次数" width="">
          <template v-slot="scope">
            <el-input v-model.number="scope.row.use_total" placeholder="赠送次数"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="充值次数优惠折扣" width="">
          <template v-slot="scope">
            <el-input v-model.number="scope.row.discount" placeholder="充值次数优惠折扣"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="媒体容量">
          <template v-slot="scope">
            <el-input v-model="scope.row.media" placeholder="媒体容量"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="是否活动">
          <template v-slot="scope">
            <el-switch v-model="scope.row.is_active" active-value="1" active-text="开启" inactive-value="0"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template v-slot="scope">
            <el-popconfirm title="确定删除此行？" @confirm="del_class(scope.$index)" >
              <template #reference>
                <el-button type="danger" size="mini" slot="reference">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="display">
      <div class="item">
        <div>
          <el-button type="primary" round size="small" @click="add_media">容量购买设置
            <span style="font-size: 14px;margin-left: 5px;" class="iconfont icon-add"></span></el-button>
        </div>
        <el-table :data="post.media" border stripe style="margin: 20px auto">
          <el-table-column label="价格" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.money" placeholder="价格"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="大小 / M" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.size" placeholder="大小"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-popconfirm title="确定删除此行？" @confirm="del_media(scope.$index)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="display">
      <div class="item">
        <div>
          <el-button type="primary" round size="small" @click="add_normal">普通充值设置
            <span style="font-size: 14px;margin-left: 5px;" class="iconfont icon-add"></span></el-button>
        </div>
        <el-table :data="post.recharge.normal" border stripe style="margin: 20px auto">
          <el-table-column label="充值价格" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.money" placeholder="充值价格"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="浏览次数" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.look_num" placeholder="浏览次数"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-popconfirm title="确定删除此行？" @confirm="del_normal(scope.$index)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="item">
        <div>
          <el-button type="primary" round size="small" @click="add_base">基础版充值设置
            <span style="font-size: 14px;margin-left: 5px;" class="iconfont icon-add"></span></el-button>
        </div>
        <el-table :data="post.recharge.base" border stripe style="margin: 20px auto">
          <el-table-column label="充值价格" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.money" placeholder="充值价格"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="浏览次数" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.look_num" placeholder="浏览次数"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-popconfirm title="确定删除此行？" @confirm="del_base(scope.$index)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="item">
        <div>
          <el-button type="primary" round size="small" @click="add_profession">专业版充值设置
            <span style="font-size: 14px;margin-left: 5px;" class="iconfont icon-add"></span></el-button>
        </div>
        <el-table :data="post.recharge.profession" border stripe style="margin: 20px auto">
          <el-table-column label="充值价格" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.money" placeholder="充值价格"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="浏览次数" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.look_num" placeholder="浏览次数"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-popconfirm title="确定删除此行？" @confirm="del_profession(scope.$index)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="item">
        <div>
          <el-button type="primary" round size="small" @click="add_vip">VIP版充值设置
            <span style="font-size: 14px;margin-left: 5px;" class="iconfont icon-add"></span></el-button>
        </div>
        <el-table :data="post.recharge.vip" border stripe style="margin: 20px auto">
          <el-table-column label="充值价格" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.money" placeholder="充值价格"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="浏览次数" >
            <template v-slot="scope">
              <el-input type="number" v-model.number="scope.row.look_num" placeholder="浏览次数"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template v-slot="scope">
              <el-popconfirm title="确定删除此行？" @confirm="del_vip(scope.$index)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-button type="primary" @click="submit">确定保存</el-button>
  </div>
</template>

<script>
export default {
  name: "recharge",
  data() {
    return {
      post: {
        class:[],
        recharge:{
          normal:[],base:[],profession:[],vip:[]
        },
        media:[]
      }
    }
  },
  mounted: async function () {
    try {
      await this.get_data();
    } catch (e) {
      console.log(e);
      return false;
    }
  },
  methods: {
    get_data: async function (){
      this.$_showLoading();
      let res = await this.$_api.setting('config',{type:'recharge'});
      this.$_hideLoading();
      if(res.errcode == 0 && res.data.content){
        this.post = res.data.content;
      }
    },
    add_class:function (){
      let data = {title:'',price:'',ebook_total:'',use_total:'',discount:'',remark:''};
      this.post.class.push(data);
    },
    del_class:function (index){
      console.log(index);
      this.post.class.splice(index,1);
    },
    add_media:function (){
      let data = {money: '', size: ''};
      this.post.media.push(data);
    },
    del_media:function (index){
      this.post.media.splice(index,1);
    },
    add_normal: function (){
      let data = {money: '', look_num: ''};
      this.post.recharge.normal.push(data);
    },
    del_normal:function (index){
      console.log(index);
      this.post.recharge.normal.splice(index,1);
    },
    add_base: function (){
      let data = {money: '', look_num: ''};
      this.post.recharge.base.push(data);
    },
    del_base:function (index){
      console.log(index);
      this.post.recharge.base.splice(index,1);
    },
    add_profession: function (){
      let data = {money: '', look_num: ''};
      this.post.recharge.profession.push(data);
    },
    del_profession:function (index){
      console.log(index);
      this.post.recharge.profession.splice(index,1);
    },
    add_vip: function (){
      let data = {money: '', look_num: ''};
      this.post.recharge.vip.push(data);
    },
    del_vip:function (index){
      console.log(index);
      this.post.recharge.vip.splice(index,1);
    },
    submit:async function (){
      this.$_showLoading();
      let res = await this.$_api.setting('config_update',{type:'recharge',content:this.post});
      this.$_hideLoading();
      this.$_showToast(res.errmsg,res.style);
      if(res.errcode == 0) {
        await this.get_data();
      }
    }
  }
}
</script>

<style scoped>
.display{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.item{
  width: calc(50% - 40px);
}
</style>